module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("1vWFJ"))).then(() => parcelRequire('kxlNJ'));